import { isRTL} from '../../../../../Localization';

const en = {
    category_smileys_people: 'Smileys & People',
    category_animals_nature: 'Animals & Nature',
    category_food_drink: 'Food & Drink',
    category_travel_places: 'Travel & Places',
    category_activities: 'Activities',
    category_objects: 'Objects',
    category_symbol: 'Symbols',
    category_flags: 'Flags',
    category_frequently_used: 'Frequently Used',
    search_placeholder: 'Search emojis...'
};

const he = {
    category_smileys_people: 'פרצופים ואנשים',
    category_animals_nature: 'בעלי חיים וטבע',
    category_food_drink: 'אוכל ושתייה',
    category_travel_places: 'נסיעות ומקומות',
    category_activities: 'פעילויות',
    category_objects: 'חפצים',
    category_symbol: 'סמלים',
    category_flags: 'דגלים',
    category_frequently_used: 'בשימוש תדיר',
    search_placeholder: 'חיפוש אמוג\'ים...'
};

export const texts = isRTL() ? he : en;
